import { useNavigate, Link } from 'react-router-dom';
import { Building2, Users, MapPin, ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const ROOM_IMAGE_1 = "https://customer-assets.emergentagent.com/job_bf1ebca5-1fd5-4042-b351-0048fc2281bc/artifacts/2n81eydn_20230524_153410.jpg";
const ROOM_IMAGE_2 = "https://customer-assets.emergentagent.com/job_dbe93cb4-9c50-4fba-b93b-913745c122fd/artifacts/3i9mb6f8_20230524_153525.jpg";

const rooms = [
  {
    id: 'salle-tiare',
    name: 'Salle Tiare',
    type: 'Réunion/Formation',
    description: "Salle de réunion climatisée et entièrement équipée, idéale pour vos réunions d'équipe, formations et séminaires.",
    capacity: 12,
    price: '2 200',
    image: ROOM_IMAGE_1
  },
  {
    id: 'salle-hibiscus',
    name: 'Salle Hibiscus',
    type: 'Réunion/Formation',
    description: 'Salle de réunion lumineuse et climatisée, parfaite pour vos séminaires, ateliers et sessions de travail en groupe.',
    capacity: 12,
    price: '2 200',
    image: ROOM_IMAGE_2
  }
];

export const RoomSiteDetailPage = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#F8FAFC] min-h-[60vh]" data-testid="room-site-detail-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">

        {/* Back link */}
        <Link
          to="/location-salles/sites"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#0D9488] mb-6 transition-colors"
          data-testid="back-to-sites"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour aux sites
        </Link>

        {/* Header */}
        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex flex-wrap gap-2 mb-3">
              <span className="bg-[#0D9488] text-white text-xs font-semibold px-2.5 py-1 rounded-md">Site actif</span>
              <span className="border border-gray-300 text-gray-600 text-xs font-medium px-2.5 py-1 rounded-md">Papeete</span>
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#1F2937] mb-4" data-testid="site-title">
              AERH Formations Tahiti
            </h1>
            <p className="text-gray-600 text-lg mb-3">
              Centre de formation professionnelle à Papeete. Salles équipées pour vos réunions, séminaires et formations.
            </p>
            <p className="flex items-center gap-1.5 text-sm text-gray-500">
              <MapPin className="w-4 h-4" />
              10 rue Georges Lagarde, 98713 Papeete, Polynésie Française, Papeete
            </p>
          </div>

          {/* Summary card */}
          <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-testid="site-summary">
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Résumé</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Salles disponibles</span>
                <span className="font-bold text-[#0D9488]">2</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">Capacité max</span>
                <span className="font-bold text-[#1F2937]">12 pers.</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">À partir de</span>
                <span className="font-bold text-[#0D9488]">2 200 F/h</span>
              </div>
            </div>
          </div>
        </div>

        {/* Rooms Section */}
        <div className="mb-8">
          <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
            <h2 className="text-2xl font-bold text-[#1F2937]" data-testid="rooms-count">
              Salles disponibles ({rooms.length})
            </h2>
            <div className="flex items-center gap-3">
              <select className="border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 bg-white" data-testid="rooms-filter-type">
                <option>Tous types</option>
                <option>Réunion/Formation</option>
              </select>
              <span className="flex items-center gap-1.5 text-sm text-gray-600 border border-gray-200 rounded-lg px-3 py-2 bg-white">
                <Users className="w-4 h-4" />
                Capacité max : <strong>12 personnes</strong>
              </span>
            </div>
          </div>

          {/* Room Cards */}
          <div className="grid md:grid-cols-2 gap-8">
            {rooms.map((room) => (
              <div key={room.id} className="rounded-xl overflow-hidden shadow-md border border-gray-200 bg-white" data-testid={`room-card-${room.id}`}>
                <div className="relative">
                  <img src={room.image} alt={room.name} className="w-full h-56 object-cover" />
                  <span className="absolute top-3 left-3 bg-[#0D9488] text-white text-xs font-semibold px-2.5 py-1 rounded-md">
                    {room.type}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-lg text-[#1F2937] mb-1">{room.name}</h3>
                  <p className="text-sm text-gray-500 mb-3">{room.description}</p>
                  <div className="flex items-center gap-1.5 text-sm text-gray-500 mb-4">
                    <Users className="w-3.5 h-3.5" />
                    {room.capacity} pers.
                  </div>
                  <div className="flex items-center justify-between">
                    <div>
                      <span className="text-xl font-bold text-[#0D9488]">{room.price} F</span>
                      <span className="text-sm text-gray-400">/h</span>
                    </div>
                    <Button
                      onClick={() => navigate(`/location-salles/reserver/${room.id}`)}
                      className="bg-[#0D9488] hover:bg-[#0F766E] text-white"
                      data-testid={`reserver-${room.id}`}
                    >
                      Réserver
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default RoomSiteDetailPage;
